









import Vue, { PropOptions } from 'vue';
import {ISelectOption as iso} from '@/class/models/typed/wild';
export type IOption = iso;
import * as models from '@/class/models/views/graph';

export default Vue.extend({
  name: 'ListChart',
  props: {
    parentData: Object,
  },
  data() {
    return {
      items: [] as any[],
      fields: [] as any[],
    };
  },
  mounted() {
    this.setList();
  },
  watch: {
    parentData: {
      deep: true,
      async handler(newValue, oldInput) {
        this.setList();
      },
    },
  },
  methods: {
    setList() {
      // console.log(this.parentData.datasets);
      if (this.parentData.datasets) {
        this.fields = this.parentData.datasets.map((v: any, i: number) => ({key: i.toString(), label: v.label, sortable: true}));
        this.fields.unshift({key: 'name', sortable: false, label: '　'});
        // console.log(this.parentData.labels)
        this.items = this.parentData.labels.map((v: any, i: number) => {
          const returnValue = {} as any;
          returnValue.name = v;
          for (const index of Object.keys(this.parentData.datasets)) {
            returnValue[index] = this.parentData.datasets[index].data[i];
          }
          return returnValue;
        });
      }
    },
  },
});
